interface QuerySubscription<T> {
  unwrap: () => Promise<T>;
  unsubscribe: () => void;
}

// RTK Query 1.x: with subscribe: false the entry is evicted before the thunk resolves and unwrap yields undefined.
export const fetchFresh = async <T>(subscription: QuerySubscription<T>): Promise<T> => {
  try {
    return await subscription.unwrap();
  } finally {
    subscription.unsubscribe();
  }
};
